var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.875,
    height: 34,
    viewBox: "0 0 31.875 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sharing",
    transform: "translate(-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3130",
    "data-name": "Path 3130",
    d: "M41.9,22.047a5.954,5.954,0,0,0-4.792,2.441l-9.419-4.823a5.639,5.639,0,0,0-.176-3.9l9.858-5.932a5.944,5.944,0,1,0-1.447-3.854,5.921,5.921,0,0,0,.416,2.149l-9.887,5.949a5.966,5.966,0,1,0,.376,7.387l9.388,4.807a5.9,5.9,0,0,0-.293,1.754A5.977,5.977,0,1,0,41.9,22.047Z",
    transform: "translate(-16)",
    fill: "#7dbaab"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharingIcon);
export default __webpack_public_path__ + "static/media/Sharing-icon.b1e79cf441bc739346ccb3c302c9cf82.svg";
export { ForwardRef as ReactComponent };